
import React, { useEffect,useState } from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';

import Chart from 'react-apexcharts';
import { useSelector, useDispatch } from 'react-redux';
import './BillingChart.css';
import { fetchPaymentDashboardData } from '../../../../redux/reducers/paymentDashboardSlice';

const BillingChart = () => {
  const dispatch = useDispatch();
  const {
    vetWiseBilling,
    top5ServiceTypesByCompletedAppointments,
    loading
  } = useSelector((state) => state.paymentDashboard);
const [view, setView] = useState('year');

  const [vetBillingData, setVetBillingData] = useState([]);
  const [vetBillingNames, setVetBillingNames] = useState([]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [serviceCounts, setServiceCounts] = useState([]);

  useEffect(() => {
    dispatch(fetchPaymentDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!vetWiseBilling) return;

    const vets = Object.keys(vetWiseBilling);
    const values = Object.values(vetWiseBilling).map((val) =>
      parseFloat(val.toFixed(2))
    );
    setVetBillingNames(vets);
    setVetBillingData(values);
  }, [vetWiseBilling]);

  useEffect(() => {
    if (!top5ServiceTypesByCompletedAppointments.length) return;

    const categories = top5ServiceTypesByCompletedAppointments.map(
      (item) => item.serviceType
    );
    const counts = top5ServiceTypesByCompletedAppointments.map(
      (item) => item.completedAppointments
    );

    setServiceCategories(categories);
    setServiceCounts(counts);
  }, [top5ServiceTypesByCompletedAppointments]);

  const revenueByCategory = {
    options: {
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: {
        bar: {
          distributed: true,
          borderRadius: 4,
          columnWidth: '50%',
        },
      },
      colors: ['#004AAD', '#A7EDE7', '#000000', '#90C2FF', '#D3D3F3'],
      xaxis: {
        categories: serviceCategories,
        labels: {
          style: { fontSize: '14px', colors: '#000' },
        },
      },
      yaxis: {
        labels: { style: { fontSize: '12px' } },
      },
      dataLabels: { enabled: false },
      grid: { yaxis: { lines: { show: false } } },
    },
    series: [
      {
        name: 'Appointments',
        data: serviceCounts,
      },
    ],
  };

  const billingContribution = {
    options: {
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          barHeight: '40%',
          dataLabels: {
            position: 'top',
          },
        },
      },
      colors: ['#004AAD', '#9E9EAF', '#C4C4D3', '#EAEAF6'],
      xaxis: {
        categories: vetBillingNames,
        labels: {
          style: { fontSize: '14px', colors: '#000' },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (_, { dataPointIndex }) =>
          vetBillingData[dataPointIndex].toLocaleString(),
        textAnchor: 'start',
        offsetX: 20,
        style: {
          colors: ['#004AAD', '#000', '#000', '#000'],
          fontSize: '14px',
          fontWeight: 600,
        },
      },
      grid: { xaxis: { lines: { show: false } } },
    },
    series: [
      {
        name: 'Billing',
        data: vetBillingData,
      },
    ],
  };

  return (
  <div className="dashboard-wrapper">
  {/* Top-left Toggle Buttons */}
  <div className="time-toggle-container">
    <ToggleButtonGroup
  value={view}
  exclusive
  onChange={(_, val) => val && setView(val)}
  size="small"
  sx={{
    backgroundColor: '#f0f2f5',
    borderRadius: '12px',

    // Apply to each toggle button in the group
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '7px',
      borderColor: 'transparent',
      color: '#333',

      // Apply only when selected
      '&.Mui-selected': {
        backgroundColor: '#005EB8',
        color: '#fff',
      },
    },
  }}
>
  <ToggleButton value="week">Week</ToggleButton>
  <ToggleButton value="month">Month</ToggleButton>
  <ToggleButton value="year">Year</ToggleButton>
</ToggleButtonGroup>
  </div>

  {/* Chart Section */}
  <div className="dashboard-container">
    {/* Chart 1 */}
    <div className="chart-section">
      <h4>Revenue by Category</h4>
      <Chart
        options={revenueByCategory.options}
        series={revenueByCategory.series}
        type="bar"
        height={300}
      />
    </div>

    {/* Chart 2 */}
    <div className="chart-section">
      <h4>Vet-wise Billing Contribution</h4>
      <Chart
        options={billingContribution.options}
        series={billingContribution.series}
        type="bar"
        height={300}
      />
    </div>
  </div>
</div>

);

};

export default BillingChart;